import { StateCreator } from "zustand";
import PublicPortalState from "@publicPortal/utils/InitialState";
import { EnforcementNoticeSearchState } from "@publicPortal/pages/search/EnforcementNotice/EnforcementNoticeSearchState";

const { initialSearchState: enInitialState, initialFilterState: enInitialFilter } = PublicPortalState.enforcementNoticeInitialSearchState();

export interface EnforcementNoticesSearchSlice {
    enforcementNoticesSearch: EnforcementNoticeSearchState;
    setEnforcementNoticesSearch: (state: EnforcementNoticeSearchState) => void;
    updateEnforcementNoticesSearch: (partialState: Partial<EnforcementNoticeSearchState>) => void;
    updateEnforcementNoticesFilter: (partialFilter: Partial<EnforcementNoticeSearchState["filter"]>) => void;
    resetEnforcementNoticesFilter: () => void;
}

export const createEnforcementNoticesSearchSlice: StateCreator<EnforcementNoticesSearchSlice, [], [], EnforcementNoticesSearchSlice> = (set) => ({
    enforcementNoticesSearch: enInitialState,
    setEnforcementNoticesSearch: (state) => set({ enforcementNoticesSearch: state }),
    updateEnforcementNoticesSearch: (partialState) =>
        set((state) => ({ enforcementNoticesSearch: { ...state.enforcementNoticesSearch, ...partialState } })),
    updateEnforcementNoticesFilter: (partialFilter) =>
        set((state) => ({
            enforcementNoticesSearch: { ...state.enforcementNoticesSearch, filter: { ...state.enforcementNoticesSearch.filter, ...partialFilter } },
        })),
    resetEnforcementNoticesFilter: () =>
        set((state) => ({ enforcementNoticesSearch: { ...state.enforcementNoticesSearch, filter: { ...enInitialFilter } } })),
});

